/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from 'react';
import { API_URL } from '@constants';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';
import { useData } from '@hooks/useData';
import { paths } from '../../types/api';
import { clearFromLocalStorage, loadFromLocalStorage } from '@utils/storage';
import { Role } from '@types';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ENDPOINT_URL_SPEC = '/api/v1/draft-registration/step-2/{uuid}' as const;
const buildEndpoint = (uuid: string, step: number) => `/draft-registration/step-${step}/${uuid}`;


export type RegistrationPasswordStepInput =
    paths[typeof ENDPOINT_URL_SPEC]['post']['requestBody']['content']['multipart/form-data'];

export type RegistrationPasswordStepSuccessResponse =
    paths[typeof ENDPOINT_URL_SPEC]['post']['responses']['200']['content']['application/json'];


export const useRegistrationPasswordStep = () => {

    const { getHeaders, getCommonParameters, handleCommonErrors } = useApiConfig();
    const { firstStep, setFirstStep, setDraft, setCarInfoStep, setOtpStep } = useData();

    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState<string | null>(null);
    const [lastResponseTime, setLastResponseTime] = useState<Date | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [validationErrors, setValidationErrors] = useState<any | null>(null);

    const request = async (props: RegistrationPasswordStepInput) => {
        const selectedRole = loadFromLocalStorage<Role>('selectedRole');
        const stepNumber = selectedRole?.name === 'Driver' ? 4 : 2;

        setLoading(true);
        setSuccess(null);
        setError(null);
        setErrorMessage(null);
        setValidationErrors(null);

        try {

            // todo: enviar apenas o pedido se houver uuid
            const uuid = firstStep?.['data']?.uuid ?? '';
            const response = await fetch(`${API_URL}${buildEndpoint(uuid, stepNumber)}`, {
                method: 'POST',
                headers: getHeaders(),
                body: JSON.stringify({ ...getCommonParameters(), ...props }),
            });

           if (!response.ok) {
                const error = new Error() as ApiError;

                try {
                    const json = await response.json();
                    error.message = json.message;
                    error.errors = json.errors;
                } catch (error: any) {
                    error.message = '';
                }

                error.statusCode = response.status;
                throw error;
            }

            const data = await response.json();
            setSuccess(data.message);

            setDraft(null);
            setOtpStep(null);
            setFirstStep(null);
            setCarInfoStep(null);

            clearFromLocalStorage('firstStep');
            clearFromLocalStorage('draft');
            clearFromLocalStorage('selectedRole');
            clearFromLocalStorage('carInfoStep');
            clearFromLocalStorage('otpStep');

        } catch (error: any) {
            handleCommonErrors(error);
            if (error.message) setErrorMessage(error.message);
            if (error.errors) setValidationErrors(error.errors);
        } finally {
            setLoading(false);
            setLastResponseTime(new Date());
        }
    };
    return { request, loading, success, error, errorMessage, validationErrors, lastResponseTime };
};
